import { Menu } from 'antd';
import { MENU_ROUTES } from '../../../../routes/routes';
import SubMenu from 'antd/lib/menu/SubMenu';
import { Link, useLocation } from 'react-router-dom';
import MenuItem from 'antd/lib/menu/MenuItem';
import { hasPermission } from '../../../../utils/permissions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useWindowSize } from '../../../../hook/useWindowSize';
import { STORAGE } from 'utils/enums/storage.enum';

const Links: React.FC<{ collapsed: boolean }> = ({ collapsed }): any => {
  const { width }: any = useWindowSize();
  const dispatch = useDispatch();
  const { token } = useSelector((state: ApplicationState) => state.auth);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);

  const [defaultIndex, setdefaultIndex] = useState([perfil === 'T' ? '/entregaNocd0' : '0']);
  const [local, setLocal] = useState<any>('');
  const { pathname } = useLocation();

  const handleClick = (e: any) => {
    if (e.keyPath.length > 1) {
      return;
    }
    if (!e.key) return;
    localStorage.setItem(STORAGE.Current_screen, e.key);
    setdefaultIndex([`${e.key}`]);
    if (e.key < 3) setLocal('');
  };
  const alert = (values: any) => {
    setLocal(values.key);
    localStorage.setItem(STORAGE.Submenu, values.key);
  };

  useEffect(() => {
    const savedModule = localStorage.getItem(STORAGE.Current_screen);
    savedModule && setdefaultIndex([savedModule]);
  }, [dispatch, token, pathname]);

  return (
    <Menu
      className="menuItens"
      style={{ maxWidth: '286px' }}
      defaultSelectedKeys={
        localStorage.getItem(STORAGE.Current_screen)
          ? [`${localStorage.getItem(STORAGE.Current_screen)}`]
          : defaultIndex
      }
      mode="inline"
      defaultOpenKeys={[
        width > 768 ? (localStorage.getItem(STORAGE.Submenu) === null ? '' : local) : '',
      ]}
      inlineCollapsed={collapsed}
      onClick={handleClick}
      selectedKeys={defaultIndex}
    >
      {MENU_ROUTES.map((item, index) => {
        return (
          hasPermission(item.roles, perfil) && (
            <>
              {item.submenu ? (
                <SubMenu
                  className="hoverItenMenu"
                  onTitleClick={alert}
                  key={item.name + index}
                  icon={<item.icon />}
                  title={item.name}
                >
                  {item.submenu?.map((subitem: any, chave: any) => {
                    return (
                      hasPermission(subitem.roles, perfil) && (
                        <Menu.Item
                          className="hoverItenMenu"
                          onClick={(evento) => handleClick(evento)}
                          key={subitem.path + chave}
                        >
                          <Link to={'/dashboard' + subitem.path}>{subitem.name}</Link>
                        </Menu.Item>
                      )
                    );
                  })}
                </SubMenu>
              ) : (
                <MenuItem key={index} className="hoverItenMenu">
                  <Link to={'/dashboard' + item.path}>
                    <item.icon />
                    <span>{item.name}</span>
                  </Link>
                </MenuItem>
              )}
            </>
          )
        );
      })}
    </Menu>
  );
};

export default Links;
